import { render, staticRenderFns } from "./DestinosMobile.vue?vue&type=template&id=6a32f05e"
import script from "./DestinosMobile.vue?vue&type=script&lang=js"
export * from "./DestinosMobile.vue?vue&type=script&lang=js"
import style0 from "./DestinosMobile.vue?vue&type=style&index=0&id=6a32f05e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports